import { useEffect, useState } from 'react';
import { ApiError, get } from './api';
import { Modal } from './ui';

/** The Demo store's "outbox": every text it would have sent (it never texts anyone). Newest first. */
export function DemoOutbox({ locationId, onClose }: { locationId: number; onClose: () => void }) {
  const [items, setItems] = useState<{ id: number; to: string; at: string; body: string }[] | null>(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    const load = () => get<{ items: { id: number; to: string; at: string; body: string }[] }>(`/api/demo/outbox?location=${locationId}`)
      .then((r) => setItems(r.items)).catch((e) => setErr(e instanceof ApiError ? e.message : 'Can’t load the outbox.'));
    load(); const x = setInterval(load, 10_000); return () => clearInterval(x);
  }, [locationId]);
  return (
    <Modal title="Demo outbox" onClose={onClose} wide>
      <div style={{ fontSize: 13, color: '#4A5561' }}>Texts this demo store would have sent show here, newest first. Made-up people are never texted. In the Demo store nothing goes out at all, not even to a real mobile number. In the Live Demo store, a real mobile number put on one of its people (Employees page) gets real texts, so those don’t show here.</div>
      {err && <div className="errbar">{err}</div>}
      {items && !items.length && <div className="stnone">Nothing yet. Try “Text schedules…” on the Week summary, “Text people to cover…” in Mid-day change, or signing in on a phone with a Demo person’s number (the code shows up here).</div>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: '60vh', overflowY: 'auto' }}>
        {items?.map((m) => (
          <div key={m.id} className="stcard"><span style={{ fontSize: 12, color: '#4A5561' }}>To {m.to} · {m.at}</span><div className="bubble" style={{ whiteSpace: 'pre-wrap' }}>{m.body}</div></div>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}><button className="tbtn primary" onClick={onClose}>Done</button></div>
    </Modal>
  );
}
